import ArrowLeft from '@assets/icons/arrow-left.svg';
import React from 'react';
import { HEADER_BUTTON_STYLE, SCREEN_PADDING } from '@/styles';
import {
  Platform,
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import { SvgProps } from 'react-native-svg';
import { useTheme } from '@/contexts/theme-context';

// https://github.com/react-navigation/react-navigation/blob/b7fa90bf8d338d1146c7f60cca485a8af2f79772/packages/stack/src/views/Header/HeaderBackButton.tsx#L186
const ANDROID_HEADER_MARGIN = 11;

interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  Icon?: React.FC<SvgProps>;
  iconProps?: SvgProps;
  onPress?: () => void;
}

export const HeaderBackButton: React.FC<Props> = ({
  containerStyle,
  Icon = ArrowLeft,
  iconProps = {},
  onPress,
}) => {
  const theme = useTheme();

  const content = (
    <View style={[styles.base, containerStyle]} testID="icon-container">
      <Icon fill={theme.colors.primary} {...iconProps} />
    </View>
  );

  return onPress ? (
    <TouchableOpacity
      onPress={onPress}
      style={containerStyle ? null : styles.button}
    >
      {content}
    </TouchableOpacity>
  ) : (
    content
  );
};

const styles = StyleSheet.create({
  base: {
    ...HEADER_BUTTON_STYLE,
    marginLeft: Platform.select({
      android: SCREEN_PADDING - ANDROID_HEADER_MARGIN,
      ios: SCREEN_PADDING,
    }),
    // Set padding since react-navigation doesn't let you specify hitSlop
    paddingRight: 12,
    paddingVertical: 12,
  },
  button: {
    // Undo the margin when used as a button for headerLeft
    marginLeft: Platform.select({
      android: ANDROID_HEADER_MARGIN,
    }),
  },
});
